/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Ask_Questions_ErrorInputs */

const es_tools_nexata_ask_questions_error = /** @type {(inputs: Tools_Nexata_Ask_Questions_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al generar preguntas`)
};

const en_tools_nexata_ask_questions_error = /** @type {(inputs: Tools_Nexata_Ask_Questions_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error generating questions`)
};

/**
* | output |
* | --- |
* | "Error generating questions" |
*
* @param {Tools_Nexata_Ask_Questions_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_ask_questions_error = /** @type {((inputs?: Tools_Nexata_Ask_Questions_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Ask_Questions_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_ask_questions_error(inputs)
	return en_tools_nexata_ask_questions_error(inputs)
});
export { tools_nexata_ask_questions_error as "tools.nexata.ask_questions_error" }